<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="11">
            <b-input-group>
                <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.uraian" @keyup.13.native="search()" placeholder="Budget Description" style="width:30% !important;"></b-form-input>
                  <b-form-input v-model="tblData.nomor" @keyup.13.native="search()" placeholder="Budget Number" class="ml-1"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
            </b-input-group>
          </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblBudget" style="font-size:smaller;" 
          responsive
          striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(nomorproduksi)="data">
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; width:100px !important;">
          {{ data.item.nomorproduksi }}</div>
        </template>
        <template v-slot:cell(startdate)="data">
          {{ data.item.startdate | moment("DDMMMYYYY") }} - {{ data.item.finishdate | moment("DDMMMYYYY") }}
        </template>
        <template v-slot:cell(budgettotal)="data">
          {{data.item.budgettotal | numFormat}}
        </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import budgetproduksi from "../../apis/budgetproduksi";

export default {
  data() {
    return {
      fields: [
          {
            key: "nomor",
            thStyle: "width:120px",
            label: "Budget Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Create Date",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true,
          },
          {
            key: "lokasi",
            label: "Location",
            sortable: true,
          },
          {
            key: "nomorproduksi",
            thStyle: "width:100px",
            label: "No.Product/Eps.",
            sortable: true
          },
          {
            key: "jmlproduksi",
            thStyle: "width:40px",
            label: "QTY",
            sortable: true
          },
          {
            key: "startdate",
            thStyle: "width:150px",
            label: "Schedule",
            sortable: true
          },
          {
            key: "budgettotal",
            label: "Budget Total",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        status: "111",
        sortBy: 'tanggal',
        sortDesc: true
      },
      lkuLoading:false
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await budgetproduksi.list(this.tblData);      
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData={uraian:'', nomor: ''};
    },    
    keymonitor: function(event) {
        console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblBudget.refresh();
       }
    },    
    refresh() {
      this.$refs.tblBudget.refresh();
    },
    search() {
      this.tblData.page=1
      this.$refs.tblBudget.refresh();
    },

  }
};
</script>
